export default __webpack_public_path__ + "0daff3a813d1614480a9918bab82eb25.png";